import { useLoaderData } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables';
import { useSearchParams } from '../../../../../common/hooks/useSearchParams.js';
import { isAdminUser } from '../../../../../common/utils/accountUtils.js';
import { CustomerOrderListWithTable } from '../../../../../components/CustomerOrderList/CustomerOrderListWithTable.js';
import { CustomerOrders, CustomerOrdersSceneTab } from '../../../../../components/CustomerOrders/CustomerOrders.js';
import { Grid } from '../../../../../components/Grid/Grid.js';
import { useAuth } from '../../../AuthProvider.js';
import type { CustomerOrdersResponse } from '../../../../../generated/api/customerOrdersResponse.js';

export const CustomerOrdersPath = () => {
  const { authenticatedUser } = useAuth();
  const { searchResults, resultCountAggregations, total } = useLoaderData() as CustomerOrdersResponse;

  const { search, status, productType, customerOrderType } = useSearchParams<{
    search?: string;
    status?: string;
    productType?: string;
    customerOrderType?: string;
  }>();

  const isAdmin = isAdminUser(authenticatedUser);

  return (
    <CustomerOrders tab={CustomerOrdersSceneTab.CUSTOMER_ORDERS}>
      <Grid>
        <CustomerOrderListWithTable
          basePath={paths.CUSTOMER_ORDER}
          customerOrders={searchResults}
          aggregations={resultCountAggregations}
          loading={false}
          totalItems={total}
          status={status}
          searchQuery={search}
          authenticatedUser={authenticatedUser}
          productType={productType}
          orderType={customerOrderType}
          showTopic={true}
          isAdmin={isAdmin}
        />
      </Grid>
    </CustomerOrders>
  );
};
